import React,{useEffect, useState} from 'react'
import SavePartList from './savepartlist';
import { Iprops } from './savepartlistinterface';
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../const/resource";
import partsService from "../../../services/partsservice";
import helperfunctions from "../../../utils/helperfunctions";
import { selectors as headerSelector } from "../../../state/features/header";
import { useSelector } from 'react-redux';
import { selectors as globalDataSelector } from "../../../state/features/common/globaldata";
import { confirmDailog } from '../../ConfirmDailog';
import { Checkbox } from '@progress/kendo-react-inputs';
import moment from 'moment';

const DeleteBookmarkItem = (props: any) => {
    const { t } = useTranslation();
    return (
        <td><div title={t(RESOURCE.MyK_Label_Delete)} className="fa fa-trash-o deleteview" onKeyDown={() => { }} onClick={() => props.deleteBookmarkItem(props.dataItem)}></div></td>
    )
}

const SavePartListConatainer = (props: Iprops) => {
    const { selectedBookmarkItem, setSelectedBookmarkItem, listType, bookmarkItems, getBookmarkItems, setListType, getPartsListItemsForGrid, partsListItemsGrid, setBookmarkItems } = props;
    const { t } = useTranslation();
    const [isUserSelected, setIsUser] = useState<any>(true);
    const [isCustomerSelected, setIsCustomer] = useState<any>(true);
    const { globalData }: any = useSelector((state) => ({
        globalData: globalDataSelector.globaldata(state),
    }));
    const {
        headercurrentuser: { azureADId, userpreference },
    }: any = useSelector((state) => ({
        headercurrentuser: headerSelector.currentuser(state),
    }));

    useEffect(() => {
        if (isUserSelected && isCustomerSelected) {
            setListType("Both");
        }
        else if (isUserSelected) {
            setListType("User");
        }
        else if (isCustomerSelected) {
            setListType("Cust");
        }
        else {
            setListType("");
        }
    }, [isUserSelected, isCustomerSelected])

    useEffect(() => {
        props.getPartsListItems();
        setSelectedBookmarkItem([])
        getBookmarkItems();
    }, [])

    useEffect(() => {
        getPartsListItemsForGrid();
    }, [listType])

    const exportToExcel = () => {
        const model = {
            userAadId: azureADId,
            listType: listType,
            distributorCode: globalData?.DistributorCode,
            customerId: globalData?.CustomerId
        }
        partsService.exportToExcelSavedPartList(model)
            .then((response: any) => {
                if (response.downloadUrl != "" && response.downloadUrl != null) {
                    window.open(response.downloadUrl, '_blank');
                }
            })
            .catch((e: any) => {
                helperfunctions.showErrorMessage(e);
            });
    }

    const deleteItemFromPartList = (id: any) => {
        const confimObject = {
            title: t(RESOURCE.MyK_Label_Delete_Confirm_Title),
            message: t(RESOURCE.MyK_Label_Delete_Confirm_Message),
            confirmmessage: '',
            buttonLabel: {
                yes: t(RESOURCE.MyK_Label_Yes),
                no: t(RESOURCE.MyK_Label_No),
            },
            yesOnclick: () => {
                partsService.deleteItemFromPartList(id)
                    .then((response: any) => {
                        if (response.isSuccessful) {
                            helperfunctions.showSuccessMessageTop((response.message && response.message != "") ? response.message : t(RESOURCE.MyK_HealthLabel_Deleted_Success_Message));
                            props.getPartsListItemsForGrid();
                            props?.getPartsListItems();
                        }
                        else
                            helperfunctions.showErrorMessageTop((response.message && response.message != "") ? response.message : t(RESOURCE.MyK_HealthLabel_Deleted_Error_Message));
                    })
                    .catch((e: any) => {
                        helperfunctions.showErrorMessage(e);

                    });
            },
            noOnclick: () => {
            },
        }
        confirmDailog(confimObject);
    }

    const deleteBookmarkItem = (item: any) => {
        const confimObject = {
            title: t(RESOURCE.MyK_Label_Delete_Confirm_Title),
            message: t(RESOURCE.MyK_Label_Delete_Confirm_Message),
            confirmmessage: '',
            buttonLabel: {
                yes: t(RESOURCE.MyK_Label_Yes),
                no: t(RESOURCE.MyK_Label_No),
            },
            yesOnclick: () => {
                deleteBookmarkItemService(item);
            },
            noOnclick: () => {
            },
        }
        confirmDailog(confimObject);
    }

    const deleteBookmarkItemService = (item :any) => {
        const model = [{
            userAadId: azureADId,
            distributorCode: globalData?.DistributorCode,
            branchCode: globalData?.BranchCode,
            manufacturer: {
                code: "",
                name: item?.manufacturerName ?? ""
            },
            partNumber: item?.partNumber,
            quantity: item?.quantity,
            partDescription: item?.partDescription ?? "",
            model: "",
            serialNumber: "",
            machineId: 0
        }];
        partsService.removeBookmark(model)
            .then((response: any) => {
                if (response.isSuccess) {
                    helperfunctions.showSuccessMessageTop((response.message && response.message != "") ? response.message : t(RESOURCE.MyK_HealthLabel_Deleted_Success_Message));
                    props?.getBookmarkItems();
                }
                else
                    helperfunctions.showErrorMessageTop((response.message && response.message != "") ? response.message : t(RESOURCE.MyK_HealthLabel_Deleted_Error_Message));
            })
            .catch((e: any) => {
                helperfunctions.showErrorMessage(e);

            });
    }

    const onSelectionChange = (event: any, dataItem: any) => {
        if (event.target.checked) {
            const list = [...selectedBookmarkItem, dataItem];
            setSelectedBookmarkItem(list);
        }
        else {
            setSelectedBookmarkItem((current :any) =>
                current.filter((t:any) => {
                    return t.partNumber !== dataItem.partNumber;
                }),
            );
        }
    }

    const PartListNameView = (item:any) =>{
        return(
            <td>{item.row.dataItem.partsListName}<span className='ml-1'>{item?.row.dataItem?.totalRowCount > 0 ? `(${item?.row.dataItem?.totalRowCount})` : ""}</span></td>
        )
    }

    const CreatedDateView = (item: any) => {
        return (
            <td>{item.dataItem.creationDate ? helperfunctions.DateFormatbasedONRegion(item.dataItem.creationDate, userpreference?.culture) : ""}</td>
        )
    }

    const CheckboxActionParts = (props: any) => {
        const handleOnChange = (e: any) => {
            props.onChange({
                dataItem: props.dataItem,
                field: props.field,
                syntheticEvent: e.syntheticEvent,
                value: e.target.value
            });
        }
        return (
            <td>
                <div className="machinecolumn quantity-value">
                    <div className="machinecheckbox_wrapper">
                        <Checkbox value={props.dataItem.checked} onChange={handleOnChange}></Checkbox>
                    </div>
                </div>
            </td>
            )
    }

    const Deleteaction = (item:any) => {
        return (
            <td><div title={t(RESOURCE.MyK_Label_Delete)} className="fa fa-trash-o deleteview" onKeyDown={() => { }} onClick={() => deleteItemFromPartList(item.row.dataItem.partsListID)}></div></td>
            )
    }

    const QuantityColumn = (props: any) => {
        let [count, setCount] = useState(props.dataItem.quantity);
        function onChange(e: any, value: any) {
            const updatedItems = bookmarkItems.map((t: any) => {
                if (t.partNumber == props.dataItem.partNumber) {
                    t.quantity = value;
                }
                return t;
            })
            setBookmarkItems(updatedItems);
            
        }
        function incrementCount(e: any) {
            let cnt = count + 1;
            if (cnt <= 9999) {
                setCount(cnt);
                onChange(e, cnt);
            }
        }
        function decrementCount(e: any) {
            if (count === 1) {
                setCount(1);
            } else {
                let cnt = count - 1;
                setCount(cnt);
                onChange(e, cnt);
            }
        }

        const handleQntChange = (event: any) => {
            const value = parseInt(event.target.value);
            if (value <= 0) {
                setCount(1);
            }
            else if (value > 9999) {
                setCount(9999);
            }
            else {
                    setCount(isNaN(value) ? 1 : value);
            }
        }

        const handleOnBlur = (event: any) => {
            const value = parseInt(event.target.value);
            onChange(event, value);
        }

        return (
            <td>
                <div className="quantity-value">
                    <span onClick={(e: any) => decrementCount(e)} onKeyDown={() => { }} title='Decrease' className="quantity_minus">-</span>
                    <span><input type="text" className="textfield" onBlur={handleOnBlur} onChange={handleQntChange} value={count}></input></span>
                    <span onClick={(e: any) => incrementCount(e)} onKeyDown={() => { }} title='Increase' className="quantity_plus">+</span>
                </div>
            </td>
        )
    };

    const ActionCheckboxParts = (props: any) => {
        const partNumber = props.row.dataItem.partNumber;
        return (
            <td><input type="checkbox" className="uploadpartlistcheck" checked={(selectedBookmarkItem?.filter((s: any) => s.partNumber == partNumber)?.length) > 0 ? true : false} onChange={(event: any) => onSelectionChange(event, props.row.dataItem)} /></td>
        )
    }

    const deleteBookmark = (props: any) => {
        return (<DeleteBookmarkItem dataItem={props.dataItem} deleteBookmarkItem={deleteBookmarkItem} />);
    }

    const columns = [
     
        {
            field: 'manufacturerName',
            title: t(RESOURCE.MyK_Label_ManufacturerName),
            columnMenu: 'ColumnMenu',
            sortable: true,
            width: 160,
        },
        {
            field: "partNumber",
            title: t(RESOURCE.MyK_Grid_Part_Number),
            columnMenu: 'ColumnMenu',
            sortable: true,
            width: 140,
        },
        {
            field: 'partDescription',
            title: t(RESOURCE.MyK_Grid_Description),
            columnMenu: 'ColumnMenu',
            sortable: true,
            width: 220,
        },
        {
            field: 'quantity',
            title: t(RESOURCE.MyK_Label_ShoppingCart_Quantity),
            cell: QuantityColumn,
            style: { textAlign: 'center' },
            sortable: false,
            width: 170,
            headerClassName: 'quantityHeaderColumn'
        },
        {
            field: 'machine',
            title: t(RESOURCE.MyK_Grid_Machine),
            columnMenu: 'ColumnMenu',
            sortable: true,
            width: 220,
        },
        {
            field: 'action',
            title: '',
            width: 50,
            style: { textAlign: 'center' },
            sortable: false,
            filterable: false,
            cell: (row: any) => <ActionCheckboxParts row={row} />,
            headerClassName: 'actionHeaderColumn'
        },
        {
            field: 'deleteaction',
            title: '',
            width: 50,
            style: { textAlign: 'center' },
            sortable: false,
            filterable: false,
            headerClassName: 'actionHeaderColumn',
            cell: deleteBookmark
        },
    ]

    const savePartGriddata = props.partsListItemsGrid?.map((item: any) => ({
        ...item,
        creationDate:  new Date(moment(item.creationDate).format("MM/DD/YYYY")),
    }));

    const nestedColumns = [
        {
            field: 'partsListName',
            title: t(RESOURCE.MyK_Label_ShoppingCart_Machines_Part_List_Name),
            columnMenu: 'ColumnMenu',
            sortable: true,
            cell: (row: any) => <PartListNameView row={row} />,
            width: 250,
            editable :false
        },
        {
            field: "creationDate",
            title: t(RESOURCE.MyK_Label_ShoppingCart_Creation_Date),
            columnMenu: 'ColumnMenu',
            format: "{0: MM/dd/yyyy}",
            type: "date",
            filter: "date",
            sortable: true,
            width: 240,
            editable: false,
            cell: CreatedDateView
        },
        {
            field: 'partListType',
            title: t(RESOURCE.MyK_Label_ShoppingCart_Type),
            columnMenu: 'ColumnMenu',
            sortable: true,
            width: 250,
            editable:false
        },
        {
            field: 'checked',
            title: t(RESOURCE.MyK_Label_ShoppingCart_Parts_For_Shopping_Cart),
            style: { textAlign: 'center' },
            editable: true,
            cell: CheckboxActionParts,
            width: 240,
            sortable: false,
            filterable:false,
            headerClassName: 'shoppingCartHeaderColumn'
        },
        {
            field: 'action',
            title: '',
            width: 50,
            style: { textAlign: 'center' },
            sortable: false,
            filterable:false,
            cell: (row: any) => <Deleteaction row={row} />,
        }
    ]

    return (
        <SavePartList getMiningParts={props?.getMiningParts} isFetchingPartsListItems={props?.isFetchingPartsListItems} onRefresh={props.onRefresh} getCartItems={props.getCartItems} setPartsListItemsGrid={savePartGriddata} exportToExcel={exportToExcel} setBookmarkItems={setBookmarkItems} listType={listType} setListType={setListType} partsListItemsGrid={savePartGriddata} bookmarkItems={bookmarkItems} columns={columns} nestedColumns={nestedColumns} addtoListOnClick={props.addtoListOnClick} selectedBookmarkItem={selectedBookmarkItem} setIsUser={setIsUser} setIsCustomer={setIsCustomer} isUserSelected={isUserSelected} isCustomerSelected={isCustomerSelected} />
     );
}
 
export default SavePartListConatainer;